import { SvgIcon } from '@mui/material';

const IconSetAppointment = (props) => {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
      <path d="M3.75 10H7.5V11.25H3.75V10ZM3.75 7.5H10V8.75H3.75V7.5ZM3.75 5H10V6.25H3.75V5Z" />
      <path d="M8.75 16.25H2.5V3.75H17.5V10H18.75V3.75C18.75 3.41848 18.6183 3.10054 18.3839 2.86612C18.1495 2.6317 17.8315 2.5 17.5 2.5H2.5C2.16848 2.5 1.85054 2.6317 1.61612 2.86612C1.3817 3.10054 1.25 3.41848 1.25 3.75V16.25C1.25 16.5815 1.3817 16.8995 1.61612 17.1339C1.85054 17.3683 2.16848 17.5 2.5 17.5H8.75V16.25Z" />
      <path d="M13.75 15.9938L12.1312 14.375L11.25 15.2563L13.75 17.7563L18.75 12.7562L17.8688 11.875L13.75 15.9938Z" />
    </SvgIcon>
  );
};

export default IconSetAppointment;
